const WEIGHT_UNIT_TO_GRAMS = { g: 1, kg: 1000, lb: 453.592, oz: 28.3495 };
const DEFAULT_SHIPPING_REGION = 'Metropolitana de Santiago';

function toGrams(weight, weightUnit) {
  return (weight || 0) * (WEIGHT_UNIT_TO_GRAMS[weightUnit] || 1);
}

class ShippingEstimator extends HTMLElement {
  constructor() {
    super();

    this.regionSelect = this.querySelector('[data-shipping-region-select]');
    this.resultsEl = this.querySelector('[data-shipping-results]');
    this.homePriceEl = this.querySelector('[data-shipping-home-price]');
    this.pickupPriceEl = this.querySelector('[data-shipping-pickup-price]');
    this.savingsBadgeEl = this.querySelector('[data-shipping-savings-badge]');
    this.outOfRangeEl = this.querySelector('[data-shipping-out-of-range]');
    this.loadingEl = this.querySelector('[data-shipping-loading]');

    this.freeShippingMin = FREE_SHIPPING_MIN;
    this.ratesData = null;
    this.currentVariant = this.getInitialVariant();

    this.regionSelect.addEventListener('change', this.update.bind(this));

    const quantityInput = document.getElementById(`Quantity-${this.dataset.section}`);
    if (quantityInput) {
      quantityInput.addEventListener('change', this.update.bind(this));
    }

    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      if (event.data.sectionId !== this.dataset.section) return;
      if (!event.data.variant) return;
      // .grams no existe en el payload de Dawn — el JSON de variant-selects usa "weight" (+ "weight_unit" si está seteado).
      this.currentVariant = {
        grams: toGrams(event.data.variant.weight, event.data.variant.weight_unit),
        price: event.data.variant.price,
      };
      this.update();
    });

    this.loadRates();
  }

  getInitialVariant() {
    const script = this.querySelector('[data-shipping-initial-variant]');
    if (!script) return { grams: 0, price: 0 };
    const data = JSON.parse(script.textContent);
    return { grams: toGrams(data.weight, data.weightUnit), price: data.price };
  }

  async loadRates() {
    const response = await fetch(this.dataset.ratesUrl);
    this.ratesData = await response.json();

    this.ratesData.regions.forEach((region) => {
      const option = document.createElement('option');
      option.value = region.name;
      option.textContent = region.name;
      this.regionSelect.appendChild(option);
    });

    const hasDefaultRegion = this.ratesData.regions.some((region) => region.name === DEFAULT_SHIPPING_REGION);
    if (hasDefaultRegion) {
      this.regionSelect.value = DEFAULT_SHIPPING_REGION;
      this.update();
    }
  }

  getQuantity() {
    const input = document.getElementById(`Quantity-${this.dataset.section}`);
    return input ? Number(input.value) || 1 : 1;
  }

  formatPrice(amount) {
    return '$' + amount.toLocaleString('es-CL');
  }

  async update() {
    const regionName = this.regionSelect.value;

    if (!regionName || !this.ratesData) {
      this.resultsEl.hidden = true;
      this.outOfRangeEl.hidden = true;
      this.loadingEl.hidden = true;
      return;
    }

    const region = this.ratesData.regions.find((r) => r.name === regionName);
    if (!region) return;

    this.loadingEl.hidden = false;
    this.resultsEl.hidden = true;
    this.outOfRangeEl.hidden = true;

    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();
    const quantity = this.getQuantity();

    const totalGrams =
      cart.items.reduce((sum, item) => sum + item.grams * item.quantity, 0) +
      this.currentVariant.grams * quantity;

    // El envío gratis solo se confirma con lo que YA hay en el carrito (cart.total_price),
    // igual que la barra de envío gratis existente (theme.liquid) — no con el producto que
    // se está viendo, que todavía no se agregó y podría no llegar a agregarse.
    const isFree = cart.total_price / 100 >= this.freeShippingMin;

    const tierIndex = this.ratesData.weightTiers.findIndex((maxGrams) => totalGrams <= maxGrams);

    this.loadingEl.hidden = true;

    if (tierIndex === -1) {
      this.resultsEl.hidden = true;
      this.outOfRangeEl.hidden = false;
      return;
    }

    this.outOfRangeEl.hidden = true;
    this.resultsEl.hidden = false;

    const homePrice = region.rates.domicilio[tierIndex];
    const pickupPrice = region.rates.retiro[tierIndex];

    this.homePriceEl.textContent = isFree ? 'Gratis' : this.formatPrice(homePrice);
    this.pickupPriceEl.textContent = isFree ? 'Gratis' : this.formatPrice(pickupPrice);

    if (isFree) {
      this.savingsBadgeEl.hidden = true;
    } else {
      const savingsPercent = Math.round(((homePrice - pickupPrice) / homePrice) * 100);
      this.savingsBadgeEl.hidden = savingsPercent <= 0;
      this.savingsBadgeEl.textContent = `Ahorra ${savingsPercent}%`;
    }
  }
}

customElements.define('shipping-estimator', ShippingEstimator);
